import GA4React from 'ga-4-react'
import { GA4ReactResolveInterface } from 'ga-4-react/dist/models/gtagModels'
import { deleteCookie } from './cookies'

export const initGA4 = (): Promise<GA4ReactResolveInterface | undefined> => {
  if (import.meta.env.VITE_APP_BUILD_ENV === 'production' && import.meta.env.VITE_APP_GA4_ID) {
    const ga4react = new GA4React(import.meta.env.VITE_APP_GA4_ID)
    return ga4react.initialize()
  }

  return Promise.resolve(undefined)
}

export const removeGA4 = () => {
  deleteCookie('_ga')
  // Delete the cookie _ga_${GA4ID}
  deleteCookie(`_ga_${import.meta.env.VITE_APP_GA4_ID?.replace('G-', '')}`)
}
